import { useMemo } from 'react';

import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { APP_DOCS_NAME_BY_TYPE } from '../constants/types';
import { UPLOAD_FILE_MAX_SIZE_IN_MB } from '../constants/upload';

const greenCheckIcon = (
  <SharedAsset
    alt=""
    src="/icon/micro/check-circle-green.svg"
    width={36}
  />
);
const deleteIcon = (
  <SharedAsset
    alt=""
    src="/icon/micro/trash.svg"
    width={24}
  />
);
const activePlusIcon = (
  <SharedAsset
    alt=""
    src="/icon/micro/line-plus-thin.svg"
  />
);

function UploadForm({
  handleClick,
  fileName,
  documentType,
  priorityTitle,
  handleRemoveFileSelected
}) {
  const isNotEmpty = Boolean(fileName);
  const dynamicContentByStatus = useMemo(
    () => ({
      title: fileName || (priorityTitle ?? APP_DOCS_NAME_BY_TYPE[documentType].title),
      description: isNotEmpty
        ? 'Upload complete'
        : `pdf, jpg, jpeg, png (${UPLOAD_FILE_MAX_SIZE_IN_MB} MB max)`
    }),
    [fileName, priorityTitle, documentType, isNotEmpty]
  );

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <Stack
        alignItems="center"
        direction="row"
        flex={1}
        spacing="12px"
      >
        {isNotEmpty ? (
          <IconButton
            color="primary"
            disabled
            label="check-mark"
            size="medium"
          >
            {greenCheckIcon}
          </IconButton>
        ) : (
          <IconButton
            disabled={Boolean(fileName)}
            label="upload"
            onClick={handleClick}
            size="small"
            variant="outlined"
          >
            {activePlusIcon}
          </IconButton>
        )}
        <Stack
          spacing="2px"
          width="100%"
        >
          <Text
            size="lg"
            weight="medium"
          >
            {dynamicContentByStatus.title}
          </Text>
          <Text
            color="tertiary"
            size="xs"
          >
            {dynamicContentByStatus.description}
          </Text>
        </Stack>
      </Stack>
      {Boolean(fileName) && (
        <Box maxWidth={25}>
          <IconButton
            color="primary"
            label="remove selected file"
            onClick={handleRemoveFileSelected}
            size="small"
          >
            {deleteIcon}
          </IconButton>
        </Box>
      )}
    </Stack>
  );
}

UploadForm.propTypes = {
  handleClick: PropTypes.func,
  fileName: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  priorityTitle: PropTypes.string,
  handleRemoveFileSelected: PropTypes.func.isRequired
};

export default UploadForm;
